import React, { useEffect, useState } from 'react'
import {  useAppSelector } from '../hooks/app'
import { getUser } from '../store/slices/auth-slice'
import { ROLES } from '../constants'
import { useNavigate } from 'react-router-dom'

function StudentPagesProvider({ children }: { children: React.ReactNode }) {
    const [loadPage, setLoadPage] = useState<boolean>(false)
    const user = useAppSelector(getUser)
    const navigate =useNavigate()
    useEffect(() => {
        if (user?.role !== ROLES.STUDENT) {
            navigate("/")
        }
        setLoadPage(true)
    }, [user])

    return (
        <>
            {loadPage ? <div>{children}</div> : null}
        </>
    )
}

export default StudentPagesProvider